import MustardBike from "../../Images/mustardBike.jpg";

const KeyFeatures = () => {
  return (
    <div className="container-fluid mustardBG pr oh mt-5">
      <div className="container">
        {/* destop sizes (> lg) */}
        <div className="row d-none d-lg-block">
          <div className="col-12 col-sm-8 mt-5 mb-5">
            <h3>
              Key features of
              <span className="mustardFont"> specialist travel insurance </span>
               included as standard are:
            </h3>
            <p className="mustardFont lufga">
              This policy provides all of the comprehensive cover found in the
              single trip package but allows you the freedom to use it on as
              many trips as you need.
            </p>

            <div className="row" id="row1">
              <div className="col-6 col-lg-3 align-center">
                <svg
                  className="travelIconSVG"
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                >
                  <defs>
                    <filter
                      id="Rectangle_917"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g
                    id="Group_2341"
                    data-name="Group 2341"
                    transform="translate(-955 -1300)"
                  >
                    <g id="Group_2342" data-name="Group 2342">
                      <rect
                        id="Rectangle_916"
                        data-name="Rectangle 916"
                        width="76"
                        height="76"
                        rx="17"
                        transform="translate(966 1307)"
                        fill="rgba(237,195,6,0.3)"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_917)"
                  >
                    <rect
                      id="Rectangle_917-2"
                      data-name="Rectangle 917"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <path
                    id="Path_2217"
                    data-name="Path 2217"
                    d="M1149.308,365.366a15.558,15.558,0,0,1-.478-3.813,15.253,15.253,0,0,1,14.711-15.372c6.184,0,10.9,3.214,14.429,9.825a1.047,1.047,0,0,1-1.847.985c-3.128-5.866-7.244-8.717-12.582-8.717a13.152,13.152,0,0,0-12.618,13.278,13.544,13.544,0,0,0,.538,3.813Zm39.708-19.185a14.466,14.466,0,0,0-10.791,4.623,1.047,1.047,0,1,0,1.51,1.45,12.444,12.444,0,0,1,9.281-3.979,13.152,13.152,0,0,1,12.618,13.278c0,7.5-4.52,11.333-8.151,14.412-.532.451-1.043.884-1.515,1.3-2.868,2.065-11.862,8.77-15.686,14.253-3.858-5.708-12.729-12.787-14.609-14.256-.458-.4-1.022-.837-1.653-1.33a38.711,38.711,0,0,1-4.848-4.285h-2.738a34.621,34.621,0,0,0,6.3,5.935c.6.467,1.137.886,1.573,1.264.012.011.07.057.083.067,1.218.952,11.989,9.465,14.96,15.1a1.047,1.047,0,0,0,.925.558h0a1.047,1.047,0,0,0,.925-.557c2.869-5.424,13.826-13.484,15.993-15.044.109-.079.164-.125.172-.131.459-.411.956-.832,1.473-1.27,3.752-3.181,8.891-7.536,8.891-16.008A15.253,15.253,0,0,0,1189.015,346.181Zm-17.4,31.494,2.4-7.586h.855l.992,1.514a1.059,1.059,0,0,0,.975.468,1.047,1.047,0,0,0,.869-.645l1.693-4.128.474,1.52a1.048,1.048,0,0,0,1,.735h10.087a1.047,1.047,0,0,0,0-2.094h-9.317l-1.11-3.56a1.047,1.047,0,0,0-1.968-.086s-1.827,4.426-2.041,4.978c-.358-.618-.653-.8-1.088-.8h-2.188a1.047,1.047,0,0,0-1,.731l-.976,3.089-1.005-14.117a1.047,1.047,0,0,0-2.058-.188l-2.6,10.074-1.1-2.343a1.047,1.047,0,0,0-1.807-.151l-1.648,2.37h-17a1.047,1.047,0,0,0,0,2.094h17.552a1.045,1.045,0,0,0,.859-.45l.927-1.332,1.566,3.327a1.047,1.047,0,0,0,1.961-.184l1.727-6.681.94,13.2a1.075,1.075,0,0,0,.983.969A1.024,1.024,0,0,0,1171.616,377.675Z"
                    transform="translate(-1131.995 -327.48)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0.2"
                  />
                </svg>
                <p className="travelIconLabels">
                  Up to £10,000,000 medical expenses
                </p>
              </div>
              <div className="col-6 col-lg-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1149"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_1148"
                    data-name="Rectangle 1148"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1149)"
                  >
                    <rect
                      id="Rectangle_1149-2"
                      data-name="Rectangle 1149"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2337"
                    data-name="Group 2337"
                    transform="translate(-229.048 -7.332)"
                  >
                    <path
                      id="Path_2228"
                      data-name="Path 2228"
                      d="M294.908,37.2c-.017-2.883-.034-5.766-.034-8.648a1.4,1.4,0,0,0-2.465-.906c-1.575,1.855-4.9,3.052-8.481,3.052-4.813,0-8.221-2.022-9.1-4.021a1.4,1.4,0,0,0-2.561,0c-.879,2-4.287,4.021-9.1,4.021-3.576,0-6.905-1.2-8.481-3.052a1.4,1.4,0,0,0-2.465.906c0,2.882-.017,5.765-.034,8.648s-.035,5.773-.035,8.656c0,11.4,7.985,21.935,20.839,27.5a1.4,1.4,0,0,0,1.111,0c12.854-5.564,20.84-16.1,20.84-27.5C294.942,42.972,294.925,40.086,294.908,37.2Zm-21.36,33.342c-11.488-5.17-18.6-14.583-18.6-24.686,0-2.878.017-5.758.034-8.64q.017-2.873.029-5.746a16.385,16.385,0,0,0,8.153,2.025c4.369,0,8.235-1.455,10.381-3.772,2.146,2.317,6.011,3.772,10.38,3.772a16.385,16.385,0,0,0,8.153-2.025q.009,2.873.029,5.746c.017,2.882.034,5.762.034,8.64C292.145,55.959,285.036,65.372,273.547,70.541Z"
                      transform="translate(0 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2229"
                      data-name="Path 2229"
                      d="M295.93,70.56H276.524a.7.7,0,0,0-.694.695V81.376a.7.7,0,0,0,.694.694H295.93a.7.7,0,0,0,.695-.694V71.255A.7.7,0,0,0,295.93,70.56Zm-18.712,1.389h2.12a2.339,2.339,0,0,1-2.12,2.082Zm0,8.732V78.6a2.339,2.339,0,0,1,2.12,2.082Zm18.017,0h-2.12a2.34,2.34,0,0,1,2.12-2.082Zm0-3.481a3.74,3.74,0,0,0-3.522,3.481H280.741a3.74,3.74,0,0,0-3.522-3.481V75.431a3.74,3.74,0,0,0,3.522-3.481h10.974a3.74,3.74,0,0,0,3.522,3.481Zm0-3.168a2.34,2.34,0,0,1-2.12-2.082h2.12Z"
                      transform="translate(-12.636 -23.866)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2230"
                      data-name="Path 2230"
                      d="M294.678,74.782c-1.661,0-3.013,1.7-3.013,3.786s1.352,3.786,3.013,3.786,3.013-1.7,3.013-3.786S296.34,74.782,294.678,74.782Zm0,6.183c-.88,0-1.624-1.1-1.624-2.4s.744-2.4,1.624-2.4,1.624,1.1,1.624,2.4S295.559,80.965,294.678,80.965Z"
                      transform="translate(-21.087 -26.119)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2231"
                      data-name="Path 2231"
                      d="M292.653,63.372c.63-.483,1.766-.1,2.479.826a2.876,2.876,0,0,1,.519,1.079h1.273a4.026,4.026,0,0,0-.8-1.841c-1.146-1.5-3.046-1.97-4.236-1.058a2.715,2.715,0,0,0-.8,2.9H292.4A1.626,1.626,0,0,1,292.653,63.372Z"
                      transform="translate(-20.719 -19.252)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2232"
                      data-name="Path 2232"
                      d="M281.018,57.647l7.86-6.023a3.375,3.375,0,0,0,4.434.561l.97,1.267a3.375,3.375,0,0,0-.612,4.427l-.093.071h2.061l1.815-1.391a.627.627,0,0,0,.116-.879l-5.555-7.249a.627.627,0,0,0-.879-.117L278.562,57.95H281.2A3.386,3.386,0,0,0,281.018,57.647Zm14.032-3.193,1.143,1.492-1.519,1.163A2.111,2.111,0,0,1,295.05,54.454ZM291.4,49.691l1.143,1.492a2.112,2.112,0,0,1-2.662-.328Z"
                      transform="translate(-14.094 -11.925)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">Up to £25,000 legal expenses</p>
              </div>
              <div className="col-6 col-lg-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1151"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_983"
                        data-name="Rectangle 983"
                        width="58.135"
                        height="47.046"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <rect
                    id="Rectangle_1150"
                    data-name="Rectangle 1150"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1151)"
                  >
                    <rect
                      id="Rectangle_1151-2"
                      data-name="Rectangle 1151"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2196"
                    data-name="Group 2196"
                    transform="translate(15.433 16.477)"
                    clipPath="url(#clip-path)"
                  >
                    <path
                      id="Path_2195"
                      data-name="Path 2195"
                      d="M67.389,40.465,46.162,20.981a1.8,1.8,0,0,0-.31-2.132l-.532-.532L48.042,15.6a2.912,2.912,0,0,0,.61-.9l.023.022a2.276,2.276,0,0,0,3.216,0L53.5,13.108a2.275,2.275,0,0,0,0-3.215L44.276.666a2.274,2.274,0,0,0-3.216,0L39.448,2.278a2.277,2.277,0,0,0,0,3.216l.022.022a2.906,2.906,0,0,0-.9.61L27.7,17a2.92,2.92,0,0,0-.611.9l-.021-.021a2.275,2.275,0,0,0-3.216,0L22.236,19.49a2.276,2.276,0,0,0,0,3.215l9.228,9.228a2.274,2.274,0,0,0,3.215,0l1.613-1.613a2.273,2.273,0,0,0,0-3.216l-.023-.023a2.908,2.908,0,0,0,.9-.61l2.722-2.722.532.532a1.825,1.825,0,0,0,2.132.31L62.035,45.819a3.789,3.789,0,1,0,5.354-5.354M41.7,22.925l-.493-.492,2.8-2.8.492.492ZM64.843,45.44l-.015-.257a1.931,1.931,0,0,1-1.419-.624L43.925,23.332l.977-.977L66.129,41.838a1.926,1.926,0,0,1-1.288,3.344Zm-30.5-20.285-5.327-5.327a1.066,1.066,0,0,1,0-1.507L39.89,7.444a1.067,1.067,0,0,1,1.506,0l5.329,5.329a1.067,1.067,0,0,1,0,1.506L35.849,25.155a1.066,1.066,0,0,1-1.507,0M40.765,3.6l1.613-1.612a.441.441,0,0,1,.581,0l9.227,9.227a.412.412,0,0,1,0,.581L50.573,13.4a.413.413,0,0,1-.581,0l-1.919-1.92L40.765,4.177a.412.412,0,0,1,0-.58M35.094,28.712a.4.4,0,0,1-.12.29l-1.612,1.612a.427.427,0,0,1-.581,0l-9.227-9.227a.411.411,0,0,1,0-.581L25.166,19.2a.411.411,0,0,1,.581,0l9.228,9.228a.4.4,0,0,1,.12.289"
                      transform="translate(-10.481 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2196"
                      data-name="Path 2196"
                      d="M28.617,72.742h-.9V71.1A3.522,3.522,0,0,0,24.2,67.587H7.937A3.521,3.521,0,0,0,4.421,71.1v1.637h-.9A3.521,3.521,0,0,0,0,76.259v2.306a.933.933,0,0,0,.932.932H31.2a.933.933,0,0,0,.932-.932V76.259a3.521,3.521,0,0,0-3.517-3.517m-16.525.932a.933.933,0,0,0-.932-.932H6.283V71.1a1.656,1.656,0,0,1,1.654-1.654H24.2A1.656,1.656,0,0,1,25.851,71.1v1.637H24.383a.932.932,0,1,0,0,1.863h4.234a1.656,1.656,0,0,1,1.654,1.654v1.374H1.864V76.259A1.656,1.656,0,0,1,3.518,74.6H11.16a.933.933,0,0,0,.932-.932"
                      transform="translate(0 -32.84)"
                      fill="#fff"
                    />
                  </g>
                </svg>

                <p className="travelIconLabels">
                  Up to £10,000,000 medical expenses
                </p>
              </div>
              <div className="col-6 col-lg-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1151"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_1150"
                    data-name="Rectangle 1150"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1151)"
                  >
                    <rect
                      id="Rectangle_1151-2"
                      data-name="Rectangle 1151"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2330"
                    data-name="Group 2330"
                    transform="translate(18 15.842)"
                  >
                    <g id="Group_2327" data-name="Group 2327">
                      <path
                        id="Path_2225"
                        data-name="Path 2225"
                        d="M1400.266,392.176a2.378,2.378,0,0,1-2.181-1.433l-.74-1.738a2.646,2.646,0,0,1,.621-2.957l2.371-2.227a2.64,2.64,0,0,0,.78-2.47,51.511,51.511,0,0,1-1.015-8.912l-16.045,4.9a3.567,3.567,0,0,1-4.608-3.411v-.479a4.894,4.894,0,0,1,2.387-4.191l18.237-10.817v-5.289c0-7.993,1.947-12.577,5.341-12.577s5.34,4.584,5.34,12.577h-2c0-6.327-1.343-10.579-3.342-10.579s-3.343,4.252-3.343,10.579v5.858a1,1,0,0,1-.489.86l-18.726,11.107a2.886,2.886,0,0,0-1.408,2.471v.479a1.568,1.568,0,0,0,2.027,1.5l17.317-5.29a1,1,0,0,1,1.291.955,49.673,49.673,0,0,0,.994,9.858,4.628,4.628,0,0,1-1.37,4.326l-2.372,2.227a.642.642,0,0,0-.15.717l.74,1.737a.363.363,0,0,0,.447.2l3.713-1.238a4.232,4.232,0,0,1,2.658,0l3.7,1.234a.376.376,0,0,0,.463-.208l.736-1.728a.639.639,0,0,0-.15-.715l-2.369-2.225a4.657,4.657,0,0,1-1.368-4.357c.147-.716.279-1.448.395-2.177l1.974.312c-.12.758-.258,1.52-.41,2.264a2.671,2.671,0,0,0,.778,2.5l2.368,2.225a2.645,2.645,0,0,1,.621,2.955l-.737,1.727a2.388,2.388,0,0,1-2.932,1.321l-3.7-1.234a2.227,2.227,0,0,0-1.4,0L1401,392.057A2.325,2.325,0,0,1,1400.266,392.176Z"
                        transform="translate(-1379.449 -340.577)"
                        fill="#fff"
                      />
                    </g>
                    <g
                      id="Group_2329"
                      data-name="Group 2329"
                      transform="translate(24.065 6.516)"
                    >
                      <g id="Group_2328" data-name="Group 2328">
                        <path
                          id="Path_2226"
                          data-name="Path 2226"
                          d="M1433.281,356.434a5.758,5.758,0,0,0-2.716,0l-.541-1.924a7.682,7.682,0,0,1,3.8,0Z"
                          transform="translate(-1430.024 -354.272)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_2335"
                    data-name="Group 2335"
                    transform="translate(44.051 28.869)"
                  >
                    <g
                      id="Group_2331"
                      data-name="Group 2331"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Path_2227"
                        data-name="Path 2227"
                        d="M1447.119,393.828q-.514,0-1.031-.04a13.006,13.006,0,0,1-11.851-11.85h0a12.94,12.94,0,1,1,12.882,11.891ZM1436.23,381.78a10.943,10.943,0,1,0,3.169-8.626,10.992,10.992,0,0,0-3.169,8.626Z"
                        transform="translate(-1434.197 -367.953)"
                        fill="#fff"
                      />
                    </g>
                    <g
                      id="Group_2334"
                      data-name="Group 2334"
                      transform="translate(7.627 7.626)"
                    >
                      <g
                        id="Group_2332"
                        data-name="Group 2332"
                        transform="translate(0 0)"
                      >
                        <rect
                          id="Rectangle_1157"
                          data-name="Rectangle 1157"
                          width="1.999"
                          height="13.025"
                          transform="translate(0 1.414) rotate(-45.001)"
                          fill="#fff"
                        />
                      </g>
                      <g
                        id="Group_2333"
                        data-name="Group 2333"
                        transform="translate(0)"
                      >
                        <rect
                          id="Rectangle_1158"
                          data-name="Rectangle 1158"
                          width="13.025"
                          height="1.999"
                          transform="translate(0 9.21) rotate(-45)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                </svg>

                <p className="travelIconLabels">
                  Up to £10,000 cancellation/ curtailment
                </p>
              </div>
            </div>
            <div className="row" id="row2">
              <div className="col-6 col-lg-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="travelIconSVG"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                >
                  <defs>
                    <filter
                      id="Rectangle_917"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_917)"
                  >
                    <rect
                      id="Rectangle_917-2"
                      data-name="Rectangle 917"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <rect
                    id="Rectangle_916"
                    data-name="Rectangle 916"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    id="Group_2336"
                    data-name="Group 2336"
                    transform="translate(-1252.934 -323.75)"
                  >
                    <path
                      id="Path_2218"
                      data-name="Path 2218"
                      d="M1316.885,347.131c-1.655-2.05-4.238-3.135-7.472-3.135a18.272,18.272,0,0,0-7.662,1.795c-.588.289-1.157.555-1.691.793a7.739,7.739,0,0,1-6.25,0c-.533-.238-1.1-.5-1.69-.793a18.276,18.276,0,0,0-7.662-1.795c-3.235,0-5.818,1.084-7.472,3.135a10.714,10.714,0,0,0-2.09,6.9,24.662,24.662,0,0,0,2.524,10.272c.465.929.879,1.682,1.278,2.411,1.416,2.58,2.535,4.618,4.633,12.224,3.335,12.089,5.3,14.566,7.22,14.566,1.643,0,2.25-2.611,3.63-12.254a57.153,57.153,0,0,1,.973-5.773c.527-1.582,1.525-1.846,1.776-1.888.274.046,1.261.317,1.786,1.888a51.845,51.845,0,0,1,.887,5.176.939.939,0,0,0,1.858-.267,45.083,45.083,0,0,0-.964-5.5,4.187,4.187,0,0,0-3.517-3.176h-.091a4.186,4.186,0,0,0-3.516,3.177,52.425,52.425,0,0,0-1.051,6.1c-.465,3.247-1.3,9.107-2.018,10.548-.622-.411-2.253-2.543-5.164-13.094-2.156-7.817-3.38-10.046-4.8-12.627-.391-.713-.8-1.45-1.244-2.347a22.644,22.644,0,0,1-2.326-9.433,8.911,8.911,0,0,1,1.673-5.721c1.3-1.617,3.326-2.436,6.011-2.436a16.576,16.576,0,0,1,6.835,1.6c.61.3,1.2.575,1.755.822a9.613,9.613,0,0,0,7.776,0c.555-.246,1.144-.523,1.755-.822a16.571,16.571,0,0,1,6.835-1.6c2.684,0,4.707.82,6.011,2.436a8.9,8.9,0,0,1,1.674,5.721,22.652,22.652,0,0,1-2.327,9.433c-.448.9-.853,1.634-1.244,2.347-1.417,2.581-2.641,4.81-4.8,12.627-2.895,10.493-4.525,12.659-5.154,13.087a11.188,11.188,0,0,1-.624-2.078.939.939,0,1,0-1.83.418c.526,2.3,1.054,3.637,2.2,3.638,1.923,0,3.886-2.477,7.221-14.566,2.1-7.606,3.217-9.644,4.633-12.224.4-.729.813-1.482,1.278-2.411a24.664,24.664,0,0,0,2.524-10.273A10.711,10.711,0,0,0,1316.885,347.131Z"
                      fill="#fff"
                    />
                    <path
                      id="Path_2219"
                      data-name="Path 2219"
                      d="M1330.022,431.279a.939.939,0,0,0,.773-1.08c-.123-.739-.241-1.5-.356-2.273a.939.939,0,1,0-1.857.278c.116.778.237,1.553.36,2.3a.939.939,0,0,0,.925.785A.963.963,0,0,0,1330.022,431.279Z"
                      transform="translate(-28.481 -44.108)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2220"
                      data-name="Path 2220"
                      d="M1341.331,368.175a.939.939,0,0,0,1.326-.06l2.618-2.865a.939.939,0,0,0,.137-1.072l-.672-1.27,2.592-3.109a.938.938,0,0,0,.032-1.161l-2.06-2.77a.939.939,0,1,0-1.506,1.12l1.619,2.176-2.521,3.024a.938.938,0,0,0-.109,1.04l.657,1.243-2.172,2.377A.939.939,0,0,0,1341.331,368.175Z"
                      transform="translate(-35.089 -6.098)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2221"
                      data-name="Path 2221"
                      d="M1332.441,360.211a.94.94,0,0,0-1.066.792l-.424,2.886a.939.939,0,0,0,.349.875l2.266,1.777a.939.939,0,1,0,1.159-1.478l-1.838-1.441.345-2.347A.938.938,0,0,0,1332.441,360.211Z"
                      transform="translate(-29.738 -8.598)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">Emergency dental treatment</p>
              </div>
              <div className="col-6 col-lg-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1149"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_1148"
                    data-name="Rectangle 1148"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 5)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1149)"
                  >
                    <rect
                      id="Rectangle_1149-2"
                      data-name="Rectangle 1149"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2338"
                    data-name="Group 2338"
                    transform="translate(-1030.404 -452.908)"
                  >
                    <path
                      id="Path_2233"
                      data-name="Path 2233"
                      d="M1095.533,464.593H1074.4a.792.792,0,0,0-.792.792v17.166h-.729a2.369,2.369,0,0,0-1.558.584l-6.531,5.715a6.824,6.824,0,0,0-2.168,3.622l-2.336,10.125a5.265,5.265,0,0,1-1.412,2.546l-.889.89-1.065-1.064a.793.793,0,0,0-1.12,0l-5.2,5.2a.792.792,0,0,0,0,1.121l11.7,11.7a.793.793,0,0,0,1.12,0l5.2-5.2a.793.793,0,0,0,0-1.121l-.361-.361,4.42-3.92.039-.037c1.3-1.319,3.528-5.257,3.528-6.962v-6.451c0-1.032,2.428-4.409,5.2-7.227,1.395-1.421,1.587-3.562.541-6.03a1.667,1.667,0,0,0-1.135-.967,1.649,1.649,0,0,0-1.456.345l-5.508,4.672a.868.868,0,0,0-.072.07l-4.225,4.631a.807.807,0,0,0-.124.18l-2.113,4.225,1.418.709,2.063-4.127,4.117-4.512,5.47-4.64a.06.06,0,0,1,.056-.014.081.081,0,0,1,.052.047c.551,1.3.962,3.1-.213,4.3-1.955,1.989-5.651,6.291-5.651,8.337v6.451c0,1.143-1.94,4.681-3.056,5.833l-4.469,3.964-8.033-8.032.889-.89a6.847,6.847,0,0,0,1.836-3.31l2.336-10.124a5.248,5.248,0,0,1,1.667-2.785l6.529-5.714a.786.786,0,0,1,.516-.194h.729v3.433h1.584V466.177h20.336a1.322,1.322,0,0,1,1.32,1.32v27.467a1.322,1.322,0,0,1-1.32,1.32h-16.9v1.584h1.38a4.347,4.347,0,0,0,3.982,4.212,1.511,1.511,0,0,0,.2.013,1.541,1.541,0,0,0,1.053-.418,1.636,1.636,0,0,0,.514-1.195v-2.613h9.772a2.908,2.908,0,0,0,2.9-2.9V467.5A2.908,2.908,0,0,0,1095.533,464.593Zm-32.668,56.717-10.58-10.581,4.081-4.081,10.58,10.581Zm21.336-20.8a2.761,2.761,0,0,1-2.591-2.642h2.573Z"
                      transform="translate(0 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2234"
                      data-name="Path 2234"
                      d="M1130.13,483.639a9.254,9.254,0,0,0-9.243-9.243c-.1,0-.213.007-.323.016a9.248,9.248,0,0,0-8.92,9.227,9.153,9.153,0,0,0,1.978,5.716l.886-.7h2.038a6.772,6.772,0,0,0,2.223,3.478l-.119.475a9.228,9.228,0,0,0,2.237.273c.1,0,.212-.006.323-.016A9.247,9.247,0,0,0,1130.13,483.639Zm-8.451,7.478v-2.46h1.841c-.06.162-.122.322-.188.471A3.887,3.887,0,0,1,1121.679,491.117Zm0-4.044v-2.641h2.623a16.194,16.194,0,0,1-.331,2.641Zm-8.41-4.226a7.588,7.588,0,0,1,.781-2.641h2.132a17.922,17.922,0,0,0-.3,2.641Zm4.534-2.641h2.291v2.641h-2.623A16.14,16.14,0,0,1,1117.8,480.206Zm10.7,2.641h-2.62a18.251,18.251,0,0,0-.271-2.641h2.11A7.581,7.581,0,0,1,1128.5,482.847Zm-4.2,0h-2.621v-2.641h2.291A16.33,16.33,0,0,1,1124.3,482.847Zm-2.621-4.226V476.16a4.224,4.224,0,0,1,1.834,2.461Zm-1.585-2.46v2.46h-1.841c.06-.162.122-.321.188-.471A3.889,3.889,0,0,1,1120.095,476.161Zm0,8.271v2.641H1117.8a16.364,16.364,0,0,1-.33-2.641Zm5.793,0h2.617a7.584,7.584,0,0,1-.781,2.641h-2.132A17.978,17.978,0,0,0,1125.887,484.432Zm.772-5.81h-1.432a9.069,9.069,0,0,0-.754-1.744A7.7,7.7,0,0,1,1126.66,478.621Zm-9.348-1.75c-.109.2-.216.406-.318.636a10.777,10.777,0,0,0-.414,1.114h-1.465A7.7,7.7,0,0,1,1117.312,476.871Zm-3.268,10.2a7.526,7.526,0,0,1-.771-2.641h2.616a18.258,18.258,0,0,0,.271,2.641Zm6.051,1.584v2.462a4.223,4.223,0,0,1-1.834-2.462Zm4.368,1.75c.109-.2.216-.406.318-.637a10.77,10.77,0,0,0,.414-1.114h1.466A7.71,7.71,0,0,1,1124.463,490.408Z"
                      transform="translate(-34.862 -5.578)"
                      fill="#fff"
                    />
                    <circle
                      id="Ellipse_81"
                      data-name="Ellipse 81"
                      cx="1.585"
                      cy="1.585"
                      r="1.585"
                      transform="translate(1061.2 515.564)"
                      fill="#fff"
                    />
                    <rect
                      id="Rectangle_1159"
                      data-name="Rectangle 1159"
                      width="6.338"
                      height="1.584"
                      transform="translate(1083.912 491.003)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">Loss of travel documents</p>
              </div>
              <div className="col-6 col-lg-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1151"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_1150"
                    data-name="Rectangle 1150"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1151)"
                  >
                    <rect
                      id="Rectangle_1151-2"
                      data-name="Rectangle 1151"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2339"
                    data-name="Group 2339"
                    transform="translate(-1154.992 -452.078)"
                  >
                    <path
                      id="Path_2235"
                      data-name="Path 2235"
                      d="M1204.324,468.547a21.92,21.92,0,0,1,10.84,0v2.211h2.1v-2.895a1.048,1.048,0,0,0-.484-.884c-.194-.124-2.041-1.211-7.032-1.211s-6.839,1.086-7.033,1.21a1.049,1.049,0,0,0-.485.885v2.895h2.1Z"
                      transform="translate(-11.142 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2236"
                      data-name="Path 2236"
                      d="M1240.005,512.794v12.692a1.049,1.049,0,1,0,2.1,0V512.794a1.049,1.049,0,0,0-2.1,0Z"
                      transform="translate(-33.072 -26.689)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2237"
                      data-name="Path 2237"
                      d="M1195.291,512.794v23.644a1.049,1.049,0,1,0,2.1,0V512.794a1.049,1.049,0,0,0-2.1,0Z"
                      transform="translate(-7.116 -26.689)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2238"
                      data-name="Path 2238"
                      d="M1219.131,519.994a1.049,1.049,0,0,0-1.049-1.049h-3.2a1.049,1.049,0,0,0,0,2.1h3.2A1.049,1.049,0,0,0,1219.131,519.994Z"
                      transform="translate(-17.88 -30.869)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2239"
                      data-name="Path 2239"
                      d="M1197.365,592.89a1.066,1.066,0,1,1-2.133,0v-.7h-2.1v.7a3.164,3.164,0,1,0,6.328,0v-.7h-2.1Z"
                      transform="translate(-5.864 -73.388)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2240"
                      data-name="Path 2240"
                      d="M1185.13,522.447V493.59a2.646,2.646,0,0,1,2.643-2.643h21.658a2.646,2.646,0,0,1,2.643,2.643v16.982h2.1V493.59a4.746,4.746,0,0,0-4.741-4.741h-3.346v-5.785h-2.1v5.785h-10.771v-5.785h-2.1v5.785h-3.346a4.746,4.746,0,0,0-4.74,4.741v28.858a4.746,4.746,0,0,0,4.74,4.74h7.813v-2.1h-7.813A2.646,2.646,0,0,1,1185.13,522.447Z"
                      transform="translate(0 -10.04)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2241"
                      data-name="Path 2241"
                      d="M1239.507,572.542l-4.841-4.842a10.1,10.1,0,1,0-1.478,1.488l4.836,4.836Zm-20.689-11.168a7.994,7.994,0,1,1,7.995,7.994A8,8,0,0,1,1218.817,561.374Z"
                      transform="translate(-19.555 -49.64)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2242"
                      data-name="Path 2242"
                      d="M1236.862,565.683l-4.518,5.4-2.131-2.95a1.049,1.049,0,0,0-1.7,1.228l2.92,4.043a1.049,1.049,0,0,0,.813.434h.037a1.049,1.049,0,0,0,.8-.376l5.384-6.433a1.049,1.049,0,0,0-1.608-1.346Z"
                      transform="translate(-26.285 -57.782)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">
                  Lost or delayed personal effects and baggage
                </p>
              </div>
            </div>
            <div className="row" id="row3">
              <div className="col-6 col-lg-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_917"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_916"
                    data-name="Rectangle 916"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_917)"
                  >
                    <rect
                      id="Rectangle_917-2"
                      data-name="Rectangle 917"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2340"
                    data-name="Group 2340"
                    transform="translate(-1123.132 -191.643)"
                  >
                    <path
                      id="Path_2243"
                      data-name="Path 2243"
                      d="M1196.344,222.206c-.676-1.708-1.991-3.669-6.193-3.669-4.94,0-12.762,2.767-23.913,8.459-3.076,1.57-5.929,3.216-8.714,4.823-2.22,1.281-4.317,2.49-6.288,3.515l-.2.1-9.775-6.284-7.128,3.956,6.566,7.96-.35.241c-2.278,1.571-3.073,2.828-2.578,4.079.6,1.517,2.789,1.517,3.508,1.517,3.635,0,10.614-1.641,19.145-4.5l.508-.17.114,10.41,9.134-3.616,7.314-13.136.123-.052a87.286,87.286,0,0,0,14.676-7.509C1193.547,227.46,1197.374,224.81,1196.344,222.206Zm-33,27.008-.112-10.254-1.536.535c-9.131,3.175-16.765,5.071-20.421,5.071l-.2,0-1.061-.023.823-.669a21.041,21.041,0,0,1,2.219-1.521l1.15-.7-6.48-7.856,3.445-1.912,9.723,6.251.6-.3c2.254-1.131,4.651-2.515,7.192-3.981,2.75-1.586,5.593-3.226,8.617-4.77,10.662-5.443,18.349-8.2,22.848-8.2,2.763,0,3.552,1.022,3.992,2.125l.048.12-.034.126c-.156.58-1.754,3.816-17.946,10.644l-.371.156-7.3,13.11Z"
                      fill="#fff"
                    />
                    <path
                      id="Path_2244"
                      data-name="Path 2244"
                      d="M1258.513,262.466a7.1,7.1,0,0,0-1.148,14.148q.284.022.566.022a7.1,7.1,0,0,0,7.082-7.67A7.134,7.134,0,0,0,1258.513,262.466Zm3.415,11.062a5.64,5.64,0,1,1-3.983-9.628q.226,0,.454.018a5.641,5.641,0,0,1,3.529,9.61Z"
                      transform="translate(-71.186 -26.781)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2245"
                      data-name="Path 2245"
                      d="M1266.253,272.665l-2.079,2.079-2.079-2.079-1.03,1.03,2.08,2.079-2.08,2.079,1.03,1.03,2.079-2.079,2.079,2.079,1.03-1.03-2.079-2.079,2.079-2.079Z"
                      transform="translate(-77.421 -33.015)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">Missed departure</p>
              </div>
              <div className="col-6 col-lg-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1149"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_972"
                        data-name="Rectangle 972"
                        width="47.48"
                        height="52.644"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <rect
                    id="Rectangle_1148"
                    data-name="Rectangle 1148"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1149)"
                  >
                    <rect
                      id="Rectangle_1149-2"
                      data-name="Rectangle 1149"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2193"
                    data-name="Group 2193"
                    transform="translate(20.26 15.678)"
                  >
                    <g
                      id="Group_2141"
                      data-name="Group 2141"
                      clipPath="url(#clip-path)"
                    >
                      <path
                        id="Path_2157"
                        data-name="Path 2157"
                        d="M46.825,16.708a3.313,3.313,0,0,0-1.71-1.2L34.277,12.235a3.292,3.292,0,0,0-2.536.274,3.258,3.258,0,0,0-1.2,1.163L25.8,21.509a45.309,45.309,0,0,1-6.075-2.714,2.753,2.753,0,0,0,.231-.211,9.6,9.6,0,0,0,2.678-6.626,9.431,9.431,0,0,0-.1-1.379l-1.2-8.072a2.912,2.912,0,0,0-.34-1,2.973,2.973,0,0,0-1.05-1.09,2.858,2.858,0,0,0-2.928-.03,2.893,2.893,0,0,0-1.441,2.5,2.84,2.84,0,0,0,.032.429l1.209,8.114a3.712,3.712,0,0,1,.039.536,3.768,3.768,0,0,1-.894,2.423l-3.281,2.369a5.434,5.434,0,0,0-1.845.817c-.084.057-.16.124-.24.186a5.584,5.584,0,0,0,.661-2.635,5.622,5.622,0,0,0-2.356-4.581l0,0L8.689,10.4l0,0-.206-.133,0,0A5.592,5.592,0,0,0,5.633,9.5h0A5.62,5.62,0,0,0,.909,12.058,5.6,5.6,0,0,0,0,15.117a5.622,5.622,0,0,0,2.563,4.722,5.6,5.6,0,0,0,3.056.908h0a5.664,5.664,0,0,0,2.646-.658,5.535,5.535,0,0,0,.841-.563l-.33.58a5.7,5.7,0,0,0-.744,2.867,6.829,6.829,0,0,0,.229,1.735l.177,7.129a9.57,9.57,0,0,0,3.013,6.755A1.02,1.02,0,1,0,12.849,37.1a7.5,7.5,0,0,1-2.368-5.317l-.18-7.249a1.046,1.046,0,0,0-.039-.251,4.815,4.815,0,0,1-.187-1.312,3.976,3.976,0,0,1,.119-.982,3.387,3.387,0,0,1,.358-.877l.44-.772A3.363,3.363,0,0,1,13.3,18.708a1.018,1.018,0,0,0,.4-.174l3.548-2.562a1,1,0,0,0,.158-.142,5.756,5.756,0,0,0,1.484-3.864,5.629,5.629,0,0,0-.062-.836L17.62,3.014a.846.846,0,0,1,.19-.672.862.862,0,0,1,.224-.189.841.841,0,0,1,.286-.1.769.769,0,0,1,.422.044.915.915,0,0,1,.569.712l1.2,8.072a7.48,7.48,0,0,1-2.022,6.284.739.739,0,0,1-.1.086l-1.149.83a1.02,1.02,0,0,0,.082,1.708,47.272,47.272,0,0,0,7.85,3.665,5.779,5.779,0,0,1,.592.254,1.025,1.025,0,0,0,1.325-.386l5.193-8.592a1.214,1.214,0,0,1,.451-.436,1.237,1.237,0,0,1,.953-.1l10.839,3.275a1.292,1.292,0,0,1,.665.466,1.241,1.241,0,0,1,.249.733,1.158,1.158,0,0,1-.042.309,1.221,1.221,0,0,1-.445.659,1.237,1.237,0,0,1-.736.247,1.205,1.205,0,0,1-.356-.053l-9.214-2.784a1.016,1.016,0,0,0-1.167.449L28.454,25.8a1.023,1.023,0,0,0-.105.815,3.725,3.725,0,0,1,.152,1.05c0,.056,0,.112,0,.166a1.022,1.022,0,0,0,.965,1.065l7.618.4a1.225,1.225,0,0,1,1.138.984l2.23,11.149a1.272,1.272,0,0,1,.024.242,1.232,1.232,0,0,1-.275.771,1.222,1.222,0,0,1-.711.429,1.239,1.239,0,0,1-.243.024h0a1.226,1.226,0,0,1-1.2-.986l-1.887-9.439a1.02,1.02,0,0,0-.947-.818l-6.029-.319a8.466,8.466,0,0,0-3.391.53,5.266,5.266,0,0,1-3.448,0,52.054,52.054,0,0,1-8.713-3.828,1.02,1.02,0,0,0-1.514.918l.07,2.786.249,0v.006l-.249,0h.12l-.12,0a5.767,5.767,0,0,0,2.324,4.516L21.1,41.154a.852.852,0,0,1,.257.307.868.868,0,0,1,.088.379.851.851,0,0,1-.167.505.86.86,0,0,1-.307.257.849.849,0,0,1-.885-.079,1.042,1.042,0,0,0-.195-.114l-1.548-.683a1.02,1.02,0,1,0-.823,1.866l1.447.634a2.886,2.886,0,0,0,.734.363,2.891,2.891,0,0,0,3.217-1.03,2.882,2.882,0,0,0,.568-1.719,2.889,2.889,0,0,0-1.17-2.325l-6.592-4.883a3.724,3.724,0,0,1-1.5-2.934L14.2,30.659a54.122,54.122,0,0,0,7.5,3.15,7.309,7.309,0,0,0,4.793-.023,6.488,6.488,0,0,1,2.582-.409l5.239.277,1.732,8.661a3.266,3.266,0,1,0,6.406-1.281l-2.23-11.149a3.269,3.269,0,0,0-3.03-2.621l-6.7-.353c-.018-.139-.042-.277-.07-.415l4.4-7.274,8.456,2.555a3.308,3.308,0,0,0,2.908-.516,3.272,3.272,0,0,0,1.188-1.753,3.219,3.219,0,0,0,.113-.844,3.294,3.294,0,0,0-.655-1.955M9.211,15.125a3.587,3.587,0,0,1-1.9,3.161,3.643,3.643,0,0,1-3.637-.159,3.545,3.545,0,0,1-1.213-1.321,3.583,3.583,0,0,1,.158-3.637,3.543,3.543,0,0,1,1.322-1.213,3.608,3.608,0,0,1,1.687-.42h0a3.588,3.588,0,0,1,3.161,1.9,3.622,3.622,0,0,1,.42,1.689"
                        transform="translate(0 0)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2158"
                        data-name="Path 2158"
                        d="M55.34,79.241l6.134,2.519a1.02,1.02,0,1,0,.775-1.887l-6.134-2.52a1.02,1.02,0,0,0-.775,1.887"
                        transform="translate(-27.438 -38.757)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2159"
                        data-name="Path 2159"
                        d="M54.956,92.132a1.021,1.021,0,0,0-1.02-1.02H40.285a1.02,1.02,0,1,0,0,2.04h13.65a1.021,1.021,0,0,0,1.02-1.02"
                        transform="translate(-19.692 -45.695)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2160"
                        data-name="Path 2160"
                        d="M72.422,93.913a1.021,1.021,0,0,0-1.4.348L68.7,98.124a1.02,1.02,0,0,0,1.748,1.052l2.326-3.863a1.02,1.02,0,0,0-.348-1.4"
                        transform="translate(-34.38 -47.026)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2161"
                        data-name="Path 2161"
                        d="M28.808,79.795a1.025,1.025,0,1,0,1.025,1.025,1.026,1.026,0,0,0-1.025-1.025"
                        transform="translate(-13.934 -40.019)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>
                <p className="travelIconLabels">Personal accident</p>
              </div>
            </div>
            <div className="row" id="row4">
              <div className="col-6 col-lg-3 align-center mb-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_917"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_916"
                    data-name="Rectangle 916"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_917)"
                  >
                    <rect
                      id="Rectangle_917-2"
                      data-name="Rectangle 917"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <path
                    id="Path_2246"
                    data-name="Path 2246"
                    d="M1361.487,502.887a1.087,1.087,0,0,0-1.163-1.836l-11.143,7.057v-3.25l12.306-7.794a1.087,1.087,0,0,0-.006-1.84l-18.634-11.646a1.088,1.088,0,0,0-1.164.007l-12.167,7.82-.706-.443a1.085,1.085,0,0,0-1.139-.01l-8.63,5.206a1.087,1.087,0,0,0-.047,1.831l.111.075-12.344,7.639a1.087,1.087,0,0,0,0,1.846l18.634,11.646a1.088,1.088,0,0,0,1.157,0l11.143-7.057v3.27l-11.7,7.391-18.044-12.4a1.087,1.087,0,1,0-1.231,1.791l18.634,12.81a1.086,1.086,0,0,0,1.2.023l11.144-7.04v3.233l-11.7,7.41-18.043-12.4a1.087,1.087,0,0,0-1.231,1.791l18.634,12.811a1.089,1.089,0,0,0,1.2.023l11.143-7.057v3.25l-11.7,7.41-18.043-12.4a1.087,1.087,0,1,0-1.231,1.791l18.634,12.81a1.087,1.087,0,0,0,1.2.023l11.283-7.146a1.081,1.081,0,0,0,1.535.386l9.317-6.009a1.086,1.086,0,0,0,.5-.913v-.652l12.306-7.794a1.087,1.087,0,0,0-1.163-1.836l-11.143,7.057V516.5l12.306-7.794a1.087,1.087,0,1,0-1.163-1.836l-11.143,7.057v-3.25Zm-19.207-17.1,16.585,10.365-10.844,6.867-1.729-1.085,6.659-4.21-1.453-.918a1.329,1.329,0,0,1-.3-.243,1.387,1.387,0,0,1,.3-.237l1.453-.918-9.364-5.919-.581.367a2.357,2.357,0,0,1-2.5,0l-.581-.367-6.706,4.239-1.665-1.045Zm6.95,11.719-4.978,3.147-8.994-5.645,4.719-2.983a4.545,4.545,0,0,0,3.557,0l5.691,3.6a2,2,0,0,0,.006,1.883Zm-23.267,19.483-16.572-10.357,11.689-7.233,1.53,1.034-7.333,4.636,1.452.919a1.459,1.459,0,0,1,.3.239,1.383,1.383,0,0,1-.29.234l-1.453.918,9.364,5.92.581-.367a2.314,2.314,0,0,1,2.492.007l.581.367,6.9-4.361,1.675,1.132Zm-6.958-11.707,5.57-3.521,8.662,5.854-4.987,3.152a4.542,4.542,0,0,0-3.545-.007l-5.7-3.6a2.05,2.05,0,0,0,.234-.935A2.016,2.016,0,0,0,1319.005,505.282Zm20.859,21.713V510.048a1.086,1.086,0,0,0-.479-.9l-17.65-11.929,0,0-.113-.076,6.6-3.982,18.785,11.79V521.7h0v.689Z"
                    transform="translate(-1289.619 -468.939)"
                    fill="#fff"
                  />
                </svg>
                <p className="travelIconLabels">Emergency cash</p>
              </div>
            </div>
          </div>
          <div className="col-sm-4 col-md-4">
            <img
              className="mustardBike"
              src={MustardBike}
              alt="Mustard coloured Racing bike Travel insurance"
            />
          </div>
        </div>

        {/* mobile sm md only - hidden above md*/}
        <div className="row d-block  d-lg-none">
          <div className="col-12 col-md-12 mt-5 mb-5">
            <h3>
              Key features of
              <span className="mustardFont"> our cycle travel insurance </span>
              included as standard are:
            </h3>
            <p className="mustardFont lufga">
              This policy provides all of the comprehensive cover found in the
              single trip package but allows you the freedom to use it on as
              many trips as you need.
            </p>

            <div className="row">
              <div className="col-6 col-md-3 align-center">
                <svg
                  className="travelIconSVG"
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                >
                  <defs>
                    <filter
                      id="Rectangle_917"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g
                    id="Group_2341"
                    data-name="Group 2341"
                    transform="translate(-955 -1300)"
                  >
                    <g id="Group_2342" data-name="Group 2342">
                      <rect
                        id="Rectangle_916"
                        data-name="Rectangle 916"
                        width="76"
                        height="76"
                        rx="17"
                        transform="translate(966 1307)"
                        fill="rgba(237,195,6,0.3)"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_917)"
                  >
                    <rect
                      id="Rectangle_917-2"
                      data-name="Rectangle 917"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <path
                    id="Path_2217"
                    data-name="Path 2217"
                    d="M1149.308,365.366a15.558,15.558,0,0,1-.478-3.813,15.253,15.253,0,0,1,14.711-15.372c6.184,0,10.9,3.214,14.429,9.825a1.047,1.047,0,0,1-1.847.985c-3.128-5.866-7.244-8.717-12.582-8.717a13.152,13.152,0,0,0-12.618,13.278,13.544,13.544,0,0,0,.538,3.813Zm39.708-19.185a14.466,14.466,0,0,0-10.791,4.623,1.047,1.047,0,1,0,1.51,1.45,12.444,12.444,0,0,1,9.281-3.979,13.152,13.152,0,0,1,12.618,13.278c0,7.5-4.52,11.333-8.151,14.412-.532.451-1.043.884-1.515,1.3-2.868,2.065-11.862,8.77-15.686,14.253-3.858-5.708-12.729-12.787-14.609-14.256-.458-.4-1.022-.837-1.653-1.33a38.711,38.711,0,0,1-4.848-4.285h-2.738a34.621,34.621,0,0,0,6.3,5.935c.6.467,1.137.886,1.573,1.264.012.011.07.057.083.067,1.218.952,11.989,9.465,14.96,15.1a1.047,1.047,0,0,0,.925.558h0a1.047,1.047,0,0,0,.925-.557c2.869-5.424,13.826-13.484,15.993-15.044.109-.079.164-.125.172-.131.459-.411.956-.832,1.473-1.27,3.752-3.181,8.891-7.536,8.891-16.008A15.253,15.253,0,0,0,1189.015,346.181Zm-17.4,31.494,2.4-7.586h.855l.992,1.514a1.059,1.059,0,0,0,.975.468,1.047,1.047,0,0,0,.869-.645l1.693-4.128.474,1.52a1.048,1.048,0,0,0,1,.735h10.087a1.047,1.047,0,0,0,0-2.094h-9.317l-1.11-3.56a1.047,1.047,0,0,0-1.968-.086s-1.827,4.426-2.041,4.978c-.358-.618-.653-.8-1.088-.8h-2.188a1.047,1.047,0,0,0-1,.731l-.976,3.089-1.005-14.117a1.047,1.047,0,0,0-2.058-.188l-2.6,10.074-1.1-2.343a1.047,1.047,0,0,0-1.807-.151l-1.648,2.37h-17a1.047,1.047,0,0,0,0,2.094h17.552a1.045,1.045,0,0,0,.859-.45l.927-1.332,1.566,3.327a1.047,1.047,0,0,0,1.961-.184l1.727-6.681.94,13.2a1.075,1.075,0,0,0,.983.969A1.024,1.024,0,0,0,1171.616,377.675Z"
                    transform="translate(-1131.995 -327.48)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0.2"
                  />
                </svg>
                <p className="travelIconLabels">
                  Up to £10,000,000 medical expenses
                </p>
              </div>
              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1149"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_1148"
                    data-name="Rectangle 1148"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1149)"
                  >
                    <rect
                      id="Rectangle_1149-2"
                      data-name="Rectangle 1149"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2337"
                    data-name="Group 2337"
                    transform="translate(-229.048 -7.332)"
                  >
                    <path
                      id="Path_2228"
                      data-name="Path 2228"
                      d="M294.908,37.2c-.017-2.883-.034-5.766-.034-8.648a1.4,1.4,0,0,0-2.465-.906c-1.575,1.855-4.9,3.052-8.481,3.052-4.813,0-8.221-2.022-9.1-4.021a1.4,1.4,0,0,0-2.561,0c-.879,2-4.287,4.021-9.1,4.021-3.576,0-6.905-1.2-8.481-3.052a1.4,1.4,0,0,0-2.465.906c0,2.882-.017,5.765-.034,8.648s-.035,5.773-.035,8.656c0,11.4,7.985,21.935,20.839,27.5a1.4,1.4,0,0,0,1.111,0c12.854-5.564,20.84-16.1,20.84-27.5C294.942,42.972,294.925,40.086,294.908,37.2Zm-21.36,33.342c-11.488-5.17-18.6-14.583-18.6-24.686,0-2.878.017-5.758.034-8.64q.017-2.873.029-5.746a16.385,16.385,0,0,0,8.153,2.025c4.369,0,8.235-1.455,10.381-3.772,2.146,2.317,6.011,3.772,10.38,3.772a16.385,16.385,0,0,0,8.153-2.025q.009,2.873.029,5.746c.017,2.882.034,5.762.034,8.64C292.145,55.959,285.036,65.372,273.547,70.541Z"
                      transform="translate(0 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2229"
                      data-name="Path 2229"
                      d="M295.93,70.56H276.524a.7.7,0,0,0-.694.695V81.376a.7.7,0,0,0,.694.694H295.93a.7.7,0,0,0,.695-.694V71.255A.7.7,0,0,0,295.93,70.56Zm-18.712,1.389h2.12a2.339,2.339,0,0,1-2.12,2.082Zm0,8.732V78.6a2.339,2.339,0,0,1,2.12,2.082Zm18.017,0h-2.12a2.34,2.34,0,0,1,2.12-2.082Zm0-3.481a3.74,3.74,0,0,0-3.522,3.481H280.741a3.74,3.74,0,0,0-3.522-3.481V75.431a3.74,3.74,0,0,0,3.522-3.481h10.974a3.74,3.74,0,0,0,3.522,3.481Zm0-3.168a2.34,2.34,0,0,1-2.12-2.082h2.12Z"
                      transform="translate(-12.636 -23.866)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2230"
                      data-name="Path 2230"
                      d="M294.678,74.782c-1.661,0-3.013,1.7-3.013,3.786s1.352,3.786,3.013,3.786,3.013-1.7,3.013-3.786S296.34,74.782,294.678,74.782Zm0,6.183c-.88,0-1.624-1.1-1.624-2.4s.744-2.4,1.624-2.4,1.624,1.1,1.624,2.4S295.559,80.965,294.678,80.965Z"
                      transform="translate(-21.087 -26.119)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2231"
                      data-name="Path 2231"
                      d="M292.653,63.372c.63-.483,1.766-.1,2.479.826a2.876,2.876,0,0,1,.519,1.079h1.273a4.026,4.026,0,0,0-.8-1.841c-1.146-1.5-3.046-1.97-4.236-1.058a2.715,2.715,0,0,0-.8,2.9H292.4A1.626,1.626,0,0,1,292.653,63.372Z"
                      transform="translate(-20.719 -19.252)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2232"
                      data-name="Path 2232"
                      d="M281.018,57.647l7.86-6.023a3.375,3.375,0,0,0,4.434.561l.97,1.267a3.375,3.375,0,0,0-.612,4.427l-.093.071h2.061l1.815-1.391a.627.627,0,0,0,.116-.879l-5.555-7.249a.627.627,0,0,0-.879-.117L278.562,57.95H281.2A3.386,3.386,0,0,0,281.018,57.647Zm14.032-3.193,1.143,1.492-1.519,1.163A2.111,2.111,0,0,1,295.05,54.454ZM291.4,49.691l1.143,1.492a2.112,2.112,0,0,1-2.662-.328Z"
                      transform="translate(-14.094 -11.925)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">Up to £25,000 legal expenses</p>
              </div>
              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1151"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_983"
                        data-name="Rectangle 983"
                        width="58.135"
                        height="47.046"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <rect
                    id="Rectangle_1150"
                    data-name="Rectangle 1150"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1151)"
                  >
                    <rect
                      id="Rectangle_1151-2"
                      data-name="Rectangle 1151"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2196"
                    data-name="Group 2196"
                    transform="translate(15.433 16.477)"
                    clipPath="url(#clip-path)"
                  >
                    <path
                      id="Path_2195"
                      data-name="Path 2195"
                      d="M67.389,40.465,46.162,20.981a1.8,1.8,0,0,0-.31-2.132l-.532-.532L48.042,15.6a2.912,2.912,0,0,0,.61-.9l.023.022a2.276,2.276,0,0,0,3.216,0L53.5,13.108a2.275,2.275,0,0,0,0-3.215L44.276.666a2.274,2.274,0,0,0-3.216,0L39.448,2.278a2.277,2.277,0,0,0,0,3.216l.022.022a2.906,2.906,0,0,0-.9.61L27.7,17a2.92,2.92,0,0,0-.611.9l-.021-.021a2.275,2.275,0,0,0-3.216,0L22.236,19.49a2.276,2.276,0,0,0,0,3.215l9.228,9.228a2.274,2.274,0,0,0,3.215,0l1.613-1.613a2.273,2.273,0,0,0,0-3.216l-.023-.023a2.908,2.908,0,0,0,.9-.61l2.722-2.722.532.532a1.825,1.825,0,0,0,2.132.31L62.035,45.819a3.789,3.789,0,1,0,5.354-5.354M41.7,22.925l-.493-.492,2.8-2.8.492.492ZM64.843,45.44l-.015-.257a1.931,1.931,0,0,1-1.419-.624L43.925,23.332l.977-.977L66.129,41.838a1.926,1.926,0,0,1-1.288,3.344Zm-30.5-20.285-5.327-5.327a1.066,1.066,0,0,1,0-1.507L39.89,7.444a1.067,1.067,0,0,1,1.506,0l5.329,5.329a1.067,1.067,0,0,1,0,1.506L35.849,25.155a1.066,1.066,0,0,1-1.507,0M40.765,3.6l1.613-1.612a.441.441,0,0,1,.581,0l9.227,9.227a.412.412,0,0,1,0,.581L50.573,13.4a.413.413,0,0,1-.581,0l-1.919-1.92L40.765,4.177a.412.412,0,0,1,0-.58M35.094,28.712a.4.4,0,0,1-.12.29l-1.612,1.612a.427.427,0,0,1-.581,0l-9.227-9.227a.411.411,0,0,1,0-.581L25.166,19.2a.411.411,0,0,1,.581,0l9.228,9.228a.4.4,0,0,1,.12.289"
                      transform="translate(-10.481 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2196"
                      data-name="Path 2196"
                      d="M28.617,72.742h-.9V71.1A3.522,3.522,0,0,0,24.2,67.587H7.937A3.521,3.521,0,0,0,4.421,71.1v1.637h-.9A3.521,3.521,0,0,0,0,76.259v2.306a.933.933,0,0,0,.932.932H31.2a.933.933,0,0,0,.932-.932V76.259a3.521,3.521,0,0,0-3.517-3.517m-16.525.932a.933.933,0,0,0-.932-.932H6.283V71.1a1.656,1.656,0,0,1,1.654-1.654H24.2A1.656,1.656,0,0,1,25.851,71.1v1.637H24.383a.932.932,0,1,0,0,1.863h4.234a1.656,1.656,0,0,1,1.654,1.654v1.374H1.864V76.259A1.656,1.656,0,0,1,3.518,74.6H11.16a.933.933,0,0,0,.932-.932"
                      transform="translate(0 -32.84)"
                      fill="#fff"
                    />
                  </g>
                </svg>

                <p className="travelIconLabels">
                  Up to £10,000,000 medical expenses
                </p>
              </div>
              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1151"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_1150"
                    data-name="Rectangle 1150"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1151)"
                  >
                    <rect
                      id="Rectangle_1151-2"
                      data-name="Rectangle 1151"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2330"
                    data-name="Group 2330"
                    transform="translate(18 15.842)"
                  >
                    <g id="Group_2327" data-name="Group 2327">
                      <path
                        id="Path_2225"
                        data-name="Path 2225"
                        d="M1400.266,392.176a2.378,2.378,0,0,1-2.181-1.433l-.74-1.738a2.646,2.646,0,0,1,.621-2.957l2.371-2.227a2.64,2.64,0,0,0,.78-2.47,51.511,51.511,0,0,1-1.015-8.912l-16.045,4.9a3.567,3.567,0,0,1-4.608-3.411v-.479a4.894,4.894,0,0,1,2.387-4.191l18.237-10.817v-5.289c0-7.993,1.947-12.577,5.341-12.577s5.34,4.584,5.34,12.577h-2c0-6.327-1.343-10.579-3.342-10.579s-3.343,4.252-3.343,10.579v5.858a1,1,0,0,1-.489.86l-18.726,11.107a2.886,2.886,0,0,0-1.408,2.471v.479a1.568,1.568,0,0,0,2.027,1.5l17.317-5.29a1,1,0,0,1,1.291.955,49.673,49.673,0,0,0,.994,9.858,4.628,4.628,0,0,1-1.37,4.326l-2.372,2.227a.642.642,0,0,0-.15.717l.74,1.737a.363.363,0,0,0,.447.2l3.713-1.238a4.232,4.232,0,0,1,2.658,0l3.7,1.234a.376.376,0,0,0,.463-.208l.736-1.728a.639.639,0,0,0-.15-.715l-2.369-2.225a4.657,4.657,0,0,1-1.368-4.357c.147-.716.279-1.448.395-2.177l1.974.312c-.12.758-.258,1.52-.41,2.264a2.671,2.671,0,0,0,.778,2.5l2.368,2.225a2.645,2.645,0,0,1,.621,2.955l-.737,1.727a2.388,2.388,0,0,1-2.932,1.321l-3.7-1.234a2.227,2.227,0,0,0-1.4,0L1401,392.057A2.325,2.325,0,0,1,1400.266,392.176Z"
                        transform="translate(-1379.449 -340.577)"
                        fill="#fff"
                      />
                    </g>
                    <g
                      id="Group_2329"
                      data-name="Group 2329"
                      transform="translate(24.065 6.516)"
                    >
                      <g id="Group_2328" data-name="Group 2328">
                        <path
                          id="Path_2226"
                          data-name="Path 2226"
                          d="M1433.281,356.434a5.758,5.758,0,0,0-2.716,0l-.541-1.924a7.682,7.682,0,0,1,3.8,0Z"
                          transform="translate(-1430.024 -354.272)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group_2335"
                    data-name="Group 2335"
                    transform="translate(44.051 28.869)"
                  >
                    <g
                      id="Group_2331"
                      data-name="Group 2331"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Path_2227"
                        data-name="Path 2227"
                        d="M1447.119,393.828q-.514,0-1.031-.04a13.006,13.006,0,0,1-11.851-11.85h0a12.94,12.94,0,1,1,12.882,11.891ZM1436.23,381.78a10.943,10.943,0,1,0,3.169-8.626,10.992,10.992,0,0,0-3.169,8.626Z"
                        transform="translate(-1434.197 -367.953)"
                        fill="#fff"
                      />
                    </g>
                    <g
                      id="Group_2334"
                      data-name="Group 2334"
                      transform="translate(7.627 7.626)"
                    >
                      <g
                        id="Group_2332"
                        data-name="Group 2332"
                        transform="translate(0 0)"
                      >
                        <rect
                          id="Rectangle_1157"
                          data-name="Rectangle 1157"
                          width="1.999"
                          height="13.025"
                          transform="translate(0 1.414) rotate(-45.001)"
                          fill="#fff"
                        />
                      </g>
                      <g
                        id="Group_2333"
                        data-name="Group 2333"
                        transform="translate(0)"
                      >
                        <rect
                          id="Rectangle_1158"
                          data-name="Rectangle 1158"
                          width="13.025"
                          height="1.999"
                          transform="translate(0 9.21) rotate(-45)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                </svg>

                <p className="travelIconLabels">
                  Up to £10,000 cancellation/ curtailment
                </p>
              </div>

              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="travelIconSVG"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                >
                  <defs>
                    <filter
                      id="Rectangle_917"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_917)"
                  >
                    <rect
                      id="Rectangle_917-2"
                      data-name="Rectangle 917"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <rect
                    id="Rectangle_916"
                    data-name="Rectangle 916"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    id="Group_2336"
                    data-name="Group 2336"
                    transform="translate(-1252.934 -323.75)"
                  >
                    <path
                      id="Path_2218"
                      data-name="Path 2218"
                      d="M1316.885,347.131c-1.655-2.05-4.238-3.135-7.472-3.135a18.272,18.272,0,0,0-7.662,1.795c-.588.289-1.157.555-1.691.793a7.739,7.739,0,0,1-6.25,0c-.533-.238-1.1-.5-1.69-.793a18.276,18.276,0,0,0-7.662-1.795c-3.235,0-5.818,1.084-7.472,3.135a10.714,10.714,0,0,0-2.09,6.9,24.662,24.662,0,0,0,2.524,10.272c.465.929.879,1.682,1.278,2.411,1.416,2.58,2.535,4.618,4.633,12.224,3.335,12.089,5.3,14.566,7.22,14.566,1.643,0,2.25-2.611,3.63-12.254a57.153,57.153,0,0,1,.973-5.773c.527-1.582,1.525-1.846,1.776-1.888.274.046,1.261.317,1.786,1.888a51.845,51.845,0,0,1,.887,5.176.939.939,0,0,0,1.858-.267,45.083,45.083,0,0,0-.964-5.5,4.187,4.187,0,0,0-3.517-3.176h-.091a4.186,4.186,0,0,0-3.516,3.177,52.425,52.425,0,0,0-1.051,6.1c-.465,3.247-1.3,9.107-2.018,10.548-.622-.411-2.253-2.543-5.164-13.094-2.156-7.817-3.38-10.046-4.8-12.627-.391-.713-.8-1.45-1.244-2.347a22.644,22.644,0,0,1-2.326-9.433,8.911,8.911,0,0,1,1.673-5.721c1.3-1.617,3.326-2.436,6.011-2.436a16.576,16.576,0,0,1,6.835,1.6c.61.3,1.2.575,1.755.822a9.613,9.613,0,0,0,7.776,0c.555-.246,1.144-.523,1.755-.822a16.571,16.571,0,0,1,6.835-1.6c2.684,0,4.707.82,6.011,2.436a8.9,8.9,0,0,1,1.674,5.721,22.652,22.652,0,0,1-2.327,9.433c-.448.9-.853,1.634-1.244,2.347-1.417,2.581-2.641,4.81-4.8,12.627-2.895,10.493-4.525,12.659-5.154,13.087a11.188,11.188,0,0,1-.624-2.078.939.939,0,1,0-1.83.418c.526,2.3,1.054,3.637,2.2,3.638,1.923,0,3.886-2.477,7.221-14.566,2.1-7.606,3.217-9.644,4.633-12.224.4-.729.813-1.482,1.278-2.411a24.664,24.664,0,0,0,2.524-10.273A10.711,10.711,0,0,0,1316.885,347.131Z"
                      fill="#fff"
                    />
                    <path
                      id="Path_2219"
                      data-name="Path 2219"
                      d="M1330.022,431.279a.939.939,0,0,0,.773-1.08c-.123-.739-.241-1.5-.356-2.273a.939.939,0,1,0-1.857.278c.116.778.237,1.553.36,2.3a.939.939,0,0,0,.925.785A.963.963,0,0,0,1330.022,431.279Z"
                      transform="translate(-28.481 -44.108)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2220"
                      data-name="Path 2220"
                      d="M1341.331,368.175a.939.939,0,0,0,1.326-.06l2.618-2.865a.939.939,0,0,0,.137-1.072l-.672-1.27,2.592-3.109a.938.938,0,0,0,.032-1.161l-2.06-2.77a.939.939,0,1,0-1.506,1.12l1.619,2.176-2.521,3.024a.938.938,0,0,0-.109,1.04l.657,1.243-2.172,2.377A.939.939,0,0,0,1341.331,368.175Z"
                      transform="translate(-35.089 -6.098)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2221"
                      data-name="Path 2221"
                      d="M1332.441,360.211a.94.94,0,0,0-1.066.792l-.424,2.886a.939.939,0,0,0,.349.875l2.266,1.777a.939.939,0,1,0,1.159-1.478l-1.838-1.441.345-2.347A.938.938,0,0,0,1332.441,360.211Z"
                      transform="translate(-29.738 -8.598)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">Emergency dental treatment</p>
              </div>
              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1149"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_1148"
                    data-name="Rectangle 1148"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 5)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1149)"
                  >
                    <rect
                      id="Rectangle_1149-2"
                      data-name="Rectangle 1149"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2338"
                    data-name="Group 2338"
                    transform="translate(-1030.404 -452.908)"
                  >
                    <path
                      id="Path_2233"
                      data-name="Path 2233"
                      d="M1095.533,464.593H1074.4a.792.792,0,0,0-.792.792v17.166h-.729a2.369,2.369,0,0,0-1.558.584l-6.531,5.715a6.824,6.824,0,0,0-2.168,3.622l-2.336,10.125a5.265,5.265,0,0,1-1.412,2.546l-.889.89-1.065-1.064a.793.793,0,0,0-1.12,0l-5.2,5.2a.792.792,0,0,0,0,1.121l11.7,11.7a.793.793,0,0,0,1.12,0l5.2-5.2a.793.793,0,0,0,0-1.121l-.361-.361,4.42-3.92.039-.037c1.3-1.319,3.528-5.257,3.528-6.962v-6.451c0-1.032,2.428-4.409,5.2-7.227,1.395-1.421,1.587-3.562.541-6.03a1.667,1.667,0,0,0-1.135-.967,1.649,1.649,0,0,0-1.456.345l-5.508,4.672a.868.868,0,0,0-.072.07l-4.225,4.631a.807.807,0,0,0-.124.18l-2.113,4.225,1.418.709,2.063-4.127,4.117-4.512,5.47-4.64a.06.06,0,0,1,.056-.014.081.081,0,0,1,.052.047c.551,1.3.962,3.1-.213,4.3-1.955,1.989-5.651,6.291-5.651,8.337v6.451c0,1.143-1.94,4.681-3.056,5.833l-4.469,3.964-8.033-8.032.889-.89a6.847,6.847,0,0,0,1.836-3.31l2.336-10.124a5.248,5.248,0,0,1,1.667-2.785l6.529-5.714a.786.786,0,0,1,.516-.194h.729v3.433h1.584V466.177h20.336a1.322,1.322,0,0,1,1.32,1.32v27.467a1.322,1.322,0,0,1-1.32,1.32h-16.9v1.584h1.38a4.347,4.347,0,0,0,3.982,4.212,1.511,1.511,0,0,0,.2.013,1.541,1.541,0,0,0,1.053-.418,1.636,1.636,0,0,0,.514-1.195v-2.613h9.772a2.908,2.908,0,0,0,2.9-2.9V467.5A2.908,2.908,0,0,0,1095.533,464.593Zm-32.668,56.717-10.58-10.581,4.081-4.081,10.58,10.581Zm21.336-20.8a2.761,2.761,0,0,1-2.591-2.642h2.573Z"
                      transform="translate(0 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2234"
                      data-name="Path 2234"
                      d="M1130.13,483.639a9.254,9.254,0,0,0-9.243-9.243c-.1,0-.213.007-.323.016a9.248,9.248,0,0,0-8.92,9.227,9.153,9.153,0,0,0,1.978,5.716l.886-.7h2.038a6.772,6.772,0,0,0,2.223,3.478l-.119.475a9.228,9.228,0,0,0,2.237.273c.1,0,.212-.006.323-.016A9.247,9.247,0,0,0,1130.13,483.639Zm-8.451,7.478v-2.46h1.841c-.06.162-.122.322-.188.471A3.887,3.887,0,0,1,1121.679,491.117Zm0-4.044v-2.641h2.623a16.194,16.194,0,0,1-.331,2.641Zm-8.41-4.226a7.588,7.588,0,0,1,.781-2.641h2.132a17.922,17.922,0,0,0-.3,2.641Zm4.534-2.641h2.291v2.641h-2.623A16.14,16.14,0,0,1,1117.8,480.206Zm10.7,2.641h-2.62a18.251,18.251,0,0,0-.271-2.641h2.11A7.581,7.581,0,0,1,1128.5,482.847Zm-4.2,0h-2.621v-2.641h2.291A16.33,16.33,0,0,1,1124.3,482.847Zm-2.621-4.226V476.16a4.224,4.224,0,0,1,1.834,2.461Zm-1.585-2.46v2.46h-1.841c.06-.162.122-.321.188-.471A3.889,3.889,0,0,1,1120.095,476.161Zm0,8.271v2.641H1117.8a16.364,16.364,0,0,1-.33-2.641Zm5.793,0h2.617a7.584,7.584,0,0,1-.781,2.641h-2.132A17.978,17.978,0,0,0,1125.887,484.432Zm.772-5.81h-1.432a9.069,9.069,0,0,0-.754-1.744A7.7,7.7,0,0,1,1126.66,478.621Zm-9.348-1.75c-.109.2-.216.406-.318.636a10.777,10.777,0,0,0-.414,1.114h-1.465A7.7,7.7,0,0,1,1117.312,476.871Zm-3.268,10.2a7.526,7.526,0,0,1-.771-2.641h2.616a18.258,18.258,0,0,0,.271,2.641Zm6.051,1.584v2.462a4.223,4.223,0,0,1-1.834-2.462Zm4.368,1.75c.109-.2.216-.406.318-.637a10.77,10.77,0,0,0,.414-1.114h1.466A7.71,7.71,0,0,1,1124.463,490.408Z"
                      transform="translate(-34.862 -5.578)"
                      fill="#fff"
                    />
                    <circle
                      id="Ellipse_81"
                      data-name="Ellipse 81"
                      cx="1.585"
                      cy="1.585"
                      r="1.585"
                      transform="translate(1061.2 515.564)"
                      fill="#fff"
                    />
                    <rect
                      id="Rectangle_1159"
                      data-name="Rectangle 1159"
                      width="6.338"
                      height="1.584"
                      transform="translate(1083.912 491.003)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">Loss of travel documents</p>
              </div>
              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1151"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_1150"
                    data-name="Rectangle 1150"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1151)"
                  >
                    <rect
                      id="Rectangle_1151-2"
                      data-name="Rectangle 1151"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2339"
                    data-name="Group 2339"
                    transform="translate(-1154.992 -452.078)"
                  >
                    <path
                      id="Path_2235"
                      data-name="Path 2235"
                      d="M1204.324,468.547a21.92,21.92,0,0,1,10.84,0v2.211h2.1v-2.895a1.048,1.048,0,0,0-.484-.884c-.194-.124-2.041-1.211-7.032-1.211s-6.839,1.086-7.033,1.21a1.049,1.049,0,0,0-.485.885v2.895h2.1Z"
                      transform="translate(-11.142 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2236"
                      data-name="Path 2236"
                      d="M1240.005,512.794v12.692a1.049,1.049,0,1,0,2.1,0V512.794a1.049,1.049,0,0,0-2.1,0Z"
                      transform="translate(-33.072 -26.689)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2237"
                      data-name="Path 2237"
                      d="M1195.291,512.794v23.644a1.049,1.049,0,1,0,2.1,0V512.794a1.049,1.049,0,0,0-2.1,0Z"
                      transform="translate(-7.116 -26.689)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2238"
                      data-name="Path 2238"
                      d="M1219.131,519.994a1.049,1.049,0,0,0-1.049-1.049h-3.2a1.049,1.049,0,0,0,0,2.1h3.2A1.049,1.049,0,0,0,1219.131,519.994Z"
                      transform="translate(-17.88 -30.869)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2239"
                      data-name="Path 2239"
                      d="M1197.365,592.89a1.066,1.066,0,1,1-2.133,0v-.7h-2.1v.7a3.164,3.164,0,1,0,6.328,0v-.7h-2.1Z"
                      transform="translate(-5.864 -73.388)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2240"
                      data-name="Path 2240"
                      d="M1185.13,522.447V493.59a2.646,2.646,0,0,1,2.643-2.643h21.658a2.646,2.646,0,0,1,2.643,2.643v16.982h2.1V493.59a4.746,4.746,0,0,0-4.741-4.741h-3.346v-5.785h-2.1v5.785h-10.771v-5.785h-2.1v5.785h-3.346a4.746,4.746,0,0,0-4.74,4.741v28.858a4.746,4.746,0,0,0,4.74,4.74h7.813v-2.1h-7.813A2.646,2.646,0,0,1,1185.13,522.447Z"
                      transform="translate(0 -10.04)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2241"
                      data-name="Path 2241"
                      d="M1239.507,572.542l-4.841-4.842a10.1,10.1,0,1,0-1.478,1.488l4.836,4.836Zm-20.689-11.168a7.994,7.994,0,1,1,7.995,7.994A8,8,0,0,1,1218.817,561.374Z"
                      transform="translate(-19.555 -49.64)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2242"
                      data-name="Path 2242"
                      d="M1236.862,565.683l-4.518,5.4-2.131-2.95a1.049,1.049,0,0,0-1.7,1.228l2.92,4.043a1.049,1.049,0,0,0,.813.434h.037a1.049,1.049,0,0,0,.8-.376l5.384-6.433a1.049,1.049,0,0,0-1.608-1.346Z"
                      transform="translate(-26.285 -57.782)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">
                  Lost or delayed personal effects and baggage
                </p>
              </div>

              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_917"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_916"
                    data-name="Rectangle 916"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_917)"
                  >
                    <rect
                      id="Rectangle_917-2"
                      data-name="Rectangle 917"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2340"
                    data-name="Group 2340"
                    transform="translate(-1123.132 -191.643)"
                  >
                    <path
                      id="Path_2243"
                      data-name="Path 2243"
                      d="M1196.344,222.206c-.676-1.708-1.991-3.669-6.193-3.669-4.94,0-12.762,2.767-23.913,8.459-3.076,1.57-5.929,3.216-8.714,4.823-2.22,1.281-4.317,2.49-6.288,3.515l-.2.1-9.775-6.284-7.128,3.956,6.566,7.96-.35.241c-2.278,1.571-3.073,2.828-2.578,4.079.6,1.517,2.789,1.517,3.508,1.517,3.635,0,10.614-1.641,19.145-4.5l.508-.17.114,10.41,9.134-3.616,7.314-13.136.123-.052a87.286,87.286,0,0,0,14.676-7.509C1193.547,227.46,1197.374,224.81,1196.344,222.206Zm-33,27.008-.112-10.254-1.536.535c-9.131,3.175-16.765,5.071-20.421,5.071l-.2,0-1.061-.023.823-.669a21.041,21.041,0,0,1,2.219-1.521l1.15-.7-6.48-7.856,3.445-1.912,9.723,6.251.6-.3c2.254-1.131,4.651-2.515,7.192-3.981,2.75-1.586,5.593-3.226,8.617-4.77,10.662-5.443,18.349-8.2,22.848-8.2,2.763,0,3.552,1.022,3.992,2.125l.048.12-.034.126c-.156.58-1.754,3.816-17.946,10.644l-.371.156-7.3,13.11Z"
                      fill="#fff"
                    />
                    <path
                      id="Path_2244"
                      data-name="Path 2244"
                      d="M1258.513,262.466a7.1,7.1,0,0,0-1.148,14.148q.284.022.566.022a7.1,7.1,0,0,0,7.082-7.67A7.134,7.134,0,0,0,1258.513,262.466Zm3.415,11.062a5.64,5.64,0,1,1-3.983-9.628q.226,0,.454.018a5.641,5.641,0,0,1,3.529,9.61Z"
                      transform="translate(-71.186 -26.781)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2245"
                      data-name="Path 2245"
                      d="M1266.253,272.665l-2.079,2.079-2.079-2.079-1.03,1.03,2.08,2.079-2.08,2.079,1.03,1.03,2.079-2.079,2.079,2.079,1.03-1.03-2.079-2.079,2.079-2.079Z"
                      transform="translate(-77.421 -33.015)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <p className="travelIconLabels">Missed departure</p>
              </div>
              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_1149"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_972"
                        data-name="Rectangle 972"
                        width="47.48"
                        height="52.644"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <rect
                    id="Rectangle_1148"
                    data-name="Rectangle 1148"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1149)"
                  >
                    <rect
                      id="Rectangle_1149-2"
                      data-name="Rectangle 1149"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <g
                    id="Group_2193"
                    data-name="Group 2193"
                    transform="translate(20.26 15.678)"
                  >
                    <g
                      id="Group_2141"
                      data-name="Group 2141"
                      clipPath="url(#clip-path)"
                    >
                      <path
                        id="Path_2157"
                        data-name="Path 2157"
                        d="M46.825,16.708a3.313,3.313,0,0,0-1.71-1.2L34.277,12.235a3.292,3.292,0,0,0-2.536.274,3.258,3.258,0,0,0-1.2,1.163L25.8,21.509a45.309,45.309,0,0,1-6.075-2.714,2.753,2.753,0,0,0,.231-.211,9.6,9.6,0,0,0,2.678-6.626,9.431,9.431,0,0,0-.1-1.379l-1.2-8.072a2.912,2.912,0,0,0-.34-1,2.973,2.973,0,0,0-1.05-1.09,2.858,2.858,0,0,0-2.928-.03,2.893,2.893,0,0,0-1.441,2.5,2.84,2.84,0,0,0,.032.429l1.209,8.114a3.712,3.712,0,0,1,.039.536,3.768,3.768,0,0,1-.894,2.423l-3.281,2.369a5.434,5.434,0,0,0-1.845.817c-.084.057-.16.124-.24.186a5.584,5.584,0,0,0,.661-2.635,5.622,5.622,0,0,0-2.356-4.581l0,0L8.689,10.4l0,0-.206-.133,0,0A5.592,5.592,0,0,0,5.633,9.5h0A5.62,5.62,0,0,0,.909,12.058,5.6,5.6,0,0,0,0,15.117a5.622,5.622,0,0,0,2.563,4.722,5.6,5.6,0,0,0,3.056.908h0a5.664,5.664,0,0,0,2.646-.658,5.535,5.535,0,0,0,.841-.563l-.33.58a5.7,5.7,0,0,0-.744,2.867,6.829,6.829,0,0,0,.229,1.735l.177,7.129a9.57,9.57,0,0,0,3.013,6.755A1.02,1.02,0,1,0,12.849,37.1a7.5,7.5,0,0,1-2.368-5.317l-.18-7.249a1.046,1.046,0,0,0-.039-.251,4.815,4.815,0,0,1-.187-1.312,3.976,3.976,0,0,1,.119-.982,3.387,3.387,0,0,1,.358-.877l.44-.772A3.363,3.363,0,0,1,13.3,18.708a1.018,1.018,0,0,0,.4-.174l3.548-2.562a1,1,0,0,0,.158-.142,5.756,5.756,0,0,0,1.484-3.864,5.629,5.629,0,0,0-.062-.836L17.62,3.014a.846.846,0,0,1,.19-.672.862.862,0,0,1,.224-.189.841.841,0,0,1,.286-.1.769.769,0,0,1,.422.044.915.915,0,0,1,.569.712l1.2,8.072a7.48,7.48,0,0,1-2.022,6.284.739.739,0,0,1-.1.086l-1.149.83a1.02,1.02,0,0,0,.082,1.708,47.272,47.272,0,0,0,7.85,3.665,5.779,5.779,0,0,1,.592.254,1.025,1.025,0,0,0,1.325-.386l5.193-8.592a1.214,1.214,0,0,1,.451-.436,1.237,1.237,0,0,1,.953-.1l10.839,3.275a1.292,1.292,0,0,1,.665.466,1.241,1.241,0,0,1,.249.733,1.158,1.158,0,0,1-.042.309,1.221,1.221,0,0,1-.445.659,1.237,1.237,0,0,1-.736.247,1.205,1.205,0,0,1-.356-.053l-9.214-2.784a1.016,1.016,0,0,0-1.167.449L28.454,25.8a1.023,1.023,0,0,0-.105.815,3.725,3.725,0,0,1,.152,1.05c0,.056,0,.112,0,.166a1.022,1.022,0,0,0,.965,1.065l7.618.4a1.225,1.225,0,0,1,1.138.984l2.23,11.149a1.272,1.272,0,0,1,.024.242,1.232,1.232,0,0,1-.275.771,1.222,1.222,0,0,1-.711.429,1.239,1.239,0,0,1-.243.024h0a1.226,1.226,0,0,1-1.2-.986l-1.887-9.439a1.02,1.02,0,0,0-.947-.818l-6.029-.319a8.466,8.466,0,0,0-3.391.53,5.266,5.266,0,0,1-3.448,0,52.054,52.054,0,0,1-8.713-3.828,1.02,1.02,0,0,0-1.514.918l.07,2.786.249,0v.006l-.249,0h.12l-.12,0a5.767,5.767,0,0,0,2.324,4.516L21.1,41.154a.852.852,0,0,1,.257.307.868.868,0,0,1,.088.379.851.851,0,0,1-.167.505.86.86,0,0,1-.307.257.849.849,0,0,1-.885-.079,1.042,1.042,0,0,0-.195-.114l-1.548-.683a1.02,1.02,0,1,0-.823,1.866l1.447.634a2.886,2.886,0,0,0,.734.363,2.891,2.891,0,0,0,3.217-1.03,2.882,2.882,0,0,0,.568-1.719,2.889,2.889,0,0,0-1.17-2.325l-6.592-4.883a3.724,3.724,0,0,1-1.5-2.934L14.2,30.659a54.122,54.122,0,0,0,7.5,3.15,7.309,7.309,0,0,0,4.793-.023,6.488,6.488,0,0,1,2.582-.409l5.239.277,1.732,8.661a3.266,3.266,0,1,0,6.406-1.281l-2.23-11.149a3.269,3.269,0,0,0-3.03-2.621l-6.7-.353c-.018-.139-.042-.277-.07-.415l4.4-7.274,8.456,2.555a3.308,3.308,0,0,0,2.908-.516,3.272,3.272,0,0,0,1.188-1.753,3.219,3.219,0,0,0,.113-.844,3.294,3.294,0,0,0-.655-1.955M9.211,15.125a3.587,3.587,0,0,1-1.9,3.161,3.643,3.643,0,0,1-3.637-.159,3.545,3.545,0,0,1-1.213-1.321,3.583,3.583,0,0,1,.158-3.637,3.543,3.543,0,0,1,1.322-1.213,3.608,3.608,0,0,1,1.687-.42h0a3.588,3.588,0,0,1,3.161,1.9,3.622,3.622,0,0,1,.42,1.689"
                        transform="translate(0 0)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2158"
                        data-name="Path 2158"
                        d="M55.34,79.241l6.134,2.519a1.02,1.02,0,1,0,.775-1.887l-6.134-2.52a1.02,1.02,0,0,0-.775,1.887"
                        transform="translate(-27.438 -38.757)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2159"
                        data-name="Path 2159"
                        d="M54.956,92.132a1.021,1.021,0,0,0-1.02-1.02H40.285a1.02,1.02,0,1,0,0,2.04h13.65a1.021,1.021,0,0,0,1.02-1.02"
                        transform="translate(-19.692 -45.695)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2160"
                        data-name="Path 2160"
                        d="M72.422,93.913a1.021,1.021,0,0,0-1.4.348L68.7,98.124a1.02,1.02,0,0,0,1.748,1.052l2.326-3.863a1.02,1.02,0,0,0-.348-1.4"
                        transform="translate(-34.38 -47.026)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2161"
                        data-name="Path 2161"
                        d="M28.808,79.795a1.025,1.025,0,1,0,1.025,1.025,1.026,1.026,0,0,0-1.025-1.025"
                        transform="translate(-13.934 -40.019)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>
                <p className="travelIconLabels">Personal accident</p>
              </div>

              <div className="col-6 col-md-3 align-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  className="travelIconSVG"
                >
                  <defs>
                    <filter
                      id="Rectangle_917"
                      x="0"
                      y="0"
                      width="88"
                      height="88"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <rect
                    id="Rectangle_916"
                    data-name="Rectangle 916"
                    width="76"
                    height="76"
                    rx="17"
                    transform="translate(11 7)"
                    fill="rgba(237,195,6,0.3)"
                  />
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_917)"
                  >
                    <rect
                      id="Rectangle_917-2"
                      data-name="Rectangle 917"
                      width="76"
                      height="76"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#edc306"
                    />
                  </g>
                  <path
                    id="Path_2246"
                    data-name="Path 2246"
                    d="M1361.487,502.887a1.087,1.087,0,0,0-1.163-1.836l-11.143,7.057v-3.25l12.306-7.794a1.087,1.087,0,0,0-.006-1.84l-18.634-11.646a1.088,1.088,0,0,0-1.164.007l-12.167,7.82-.706-.443a1.085,1.085,0,0,0-1.139-.01l-8.63,5.206a1.087,1.087,0,0,0-.047,1.831l.111.075-12.344,7.639a1.087,1.087,0,0,0,0,1.846l18.634,11.646a1.088,1.088,0,0,0,1.157,0l11.143-7.057v3.27l-11.7,7.391-18.044-12.4a1.087,1.087,0,1,0-1.231,1.791l18.634,12.81a1.086,1.086,0,0,0,1.2.023l11.144-7.04v3.233l-11.7,7.41-18.043-12.4a1.087,1.087,0,0,0-1.231,1.791l18.634,12.811a1.089,1.089,0,0,0,1.2.023l11.143-7.057v3.25l-11.7,7.41-18.043-12.4a1.087,1.087,0,1,0-1.231,1.791l18.634,12.81a1.087,1.087,0,0,0,1.2.023l11.283-7.146a1.081,1.081,0,0,0,1.535.386l9.317-6.009a1.086,1.086,0,0,0,.5-.913v-.652l12.306-7.794a1.087,1.087,0,0,0-1.163-1.836l-11.143,7.057V516.5l12.306-7.794a1.087,1.087,0,1,0-1.163-1.836l-11.143,7.057v-3.25Zm-19.207-17.1,16.585,10.365-10.844,6.867-1.729-1.085,6.659-4.21-1.453-.918a1.329,1.329,0,0,1-.3-.243,1.387,1.387,0,0,1,.3-.237l1.453-.918-9.364-5.919-.581.367a2.357,2.357,0,0,1-2.5,0l-.581-.367-6.706,4.239-1.665-1.045Zm6.95,11.719-4.978,3.147-8.994-5.645,4.719-2.983a4.545,4.545,0,0,0,3.557,0l5.691,3.6a2,2,0,0,0,.006,1.883Zm-23.267,19.483-16.572-10.357,11.689-7.233,1.53,1.034-7.333,4.636,1.452.919a1.459,1.459,0,0,1,.3.239,1.383,1.383,0,0,1-.29.234l-1.453.918,9.364,5.92.581-.367a2.314,2.314,0,0,1,2.492.007l.581.367,6.9-4.361,1.675,1.132Zm-6.958-11.707,5.57-3.521,8.662,5.854-4.987,3.152a4.542,4.542,0,0,0-3.545-.007l-5.7-3.6a2.05,2.05,0,0,0,.234-.935A2.016,2.016,0,0,0,1319.005,505.282Zm20.859,21.713V510.048a1.086,1.086,0,0,0-.479-.9l-17.65-11.929,0,0-.113-.076,6.6-3.982,18.785,11.79V521.7h0v.689Z"
                    transform="translate(-1289.619 -468.939)"
                    fill="#fff"
                  />
                </svg>
                <p className="travelIconLabels">Emergency cash</p>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <img
              className="mustardBike d-block d-lg-none"
              src={MustardBike}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyFeatures;
